import React, { useLayoutEffect } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themesAnimated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themesAnimated);

const RLIBarChart = ({ data }) => {
  useLayoutEffect(() => {
    const chart = am4core.create("rliBarChart", am4charts.XYChart);
    chart.data = data;

    // --- X Axis (Categories)
    const categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = "report_line_item_name";
    categoryAxis.renderer.grid.template.disabled = true;
    categoryAxis.renderer.line.strokeOpacity = 0;
    categoryAxis.renderer.labels.template.rotation = -70;
    categoryAxis.renderer.labels.template.horizontalCenter = "right";
    categoryAxis.renderer.labels.template.verticalCenter = "middle";
    categoryAxis.renderer.labels.template.wrap = true;
    categoryAxis.renderer.labels.template.maxWidth = 150;
    categoryAxis.renderer.labels.template.fontSize = 12;

    // --- Y Axis (Values)
    const valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;

    // Auto adjust max and step, but keep it clean and spaced out
    const maxValue = Math.max(...data.map((d) => d.total));
    const step = 50; // desired gap
    const roundedMax = Math.ceil(maxValue / step) * step;
    valueAxis.max = roundedMax;
    valueAxis.strictMinMax = false;

    // Style horizontal grid lines (solid, no dots)
    valueAxis.renderer.grid.template.strokeOpacity = 1;
    valueAxis.renderer.grid.template.stroke = am4core.color("#ccc");
    valueAxis.renderer.line.strokeOpacity = 0;

    // --- Bars
    const series = chart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = "total";
    series.dataFields.categoryX = "report_line_item_name";
    series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
    series.columns.template.fillOpacity = 1;
    series.columns.template.strokeWidth = 0;
    series.columns.template.fill = am4core.color("#ffce00");

    // Chart title
    const title = chart.titles.create();
    title.fontSize = 18;
    title.marginBottom = 10;
    chart.logo.disabled = true;

    return () => chart.dispose();
  }, [data]);

  return <div id="rliBarChart" style={{ width: "100%", height: "420px" }} />;
};

export default RLIBarChart;
